export { default as getIconCSSForFileProvider } from './utils/getIconCSSForFileProvider';
export { default as getIconForFileProvider } from './utils/getIconForFileProvider';
